import { SfLog } from '@app/adapters/logger'

const loadedStylesheets = new Map<string, Promise<void>>()

// Resolves when every stylesheet has loaded or failed. A failure is logged and
// not thrown, so the template still mounts, unstyled.
export const loadStylesheets = async (urls: string[]): Promise<void> => {
  await Promise.all(urls.map(loadStylesheet))
}

// The links are fetched cross-origin from the private CDN bucket, so they need
// the signed Cloud-CDN-Cookie sent along (crossorigin="use-credentials").
const loadStylesheet = (url: string): Promise<void> => {
  const existing = loadedStylesheets.get(url)

  if (existing) {
    return existing
  }

  const loaded = new Promise<void>((resolve) => {
    const link = document.createElement('link')

    link.rel = 'stylesheet'
    link.crossOrigin = 'use-credentials'
    link.href = url

    link.onload = (): void => {
      resolve()
    }
    link.onerror = (): void => {
      loadedStylesheets.delete(url)
      link.remove()
      SfLog.warn('[solid] failed to load template stylesheet', {
        extra: { url },
      })
      resolve()
    }

    document.head.appendChild(link)
  })

  loadedStylesheets.set(url, loaded)

  return loaded
}
